<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
            
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
                 <FormItem :label="$t('productPage.titleName.Page_id')" prop="pageId" style="width: 560px">
                    <Input type="text" maxlength="10" v-model.trim="formData.pageId" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('productPage.titleName.Description')" prop="description" style="width: 560px">
                    <Input type="text" v-model.trim="formData.description" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('productPage.titleName.Remark')" prop="remark" style="width: 560px">
                    <Input type="textarea" maxlength="100"  show-word-limit   v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                
                <FormItem :label="$t('productPage.titleName.Photos')" prop="photos" class="logoCon ivu-form-item-required" style="min-width: 560px;display: flex;align-items: center;">
                    <ImgUpload style="margin-top: 20px" ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="6" @setThumbUrl="setThumbUrlthumb" @removeThumbUrl='removeThumbUrl'></ImgUpload>
                </FormItem>
            </Form>
    
            <div class="flexCC">
              <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
              <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </div>
    
        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import ImgUpload from "@/views/common/upload";
import { mapState } from 'vuex'

export default {
        props: {
            showModel: Boolean,
            fn:Function,
            fn1:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            ImgUpload
        },
        data() {
            return {   
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    pageId:'',//页面编号
                    description: '',//描述
                    remark:'',//备注
                    photos:'',//图片
                },
                photoArr:[]
            }
        },

        computed:{
             ...mapState(['selectId']),
            ruleCustom(){
                return {
                    pageId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^[0-9]+$/, message: this.$t('ruleCustom.pageId'), trigger:'blur'},
                    ],
                    description: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    photos: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    remark: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ]
                }
            }

        },
        created(){
           
        },
        mounted(){
        },
        methods: {
            setThumbUrlthumb(item) {//图片上传
            //   console.log("url", item);
              let url = item.data+'_'+item.file.name
              this.photoArr.push(url)
              this.formData.photos = this.photoArr.join(',');
            },
            removeThumbUrl(index){//删除图片
               this.photoArr.splice(index,1)
               this.formData.photos = this.photoArr.join(',');
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值

                     for (let key in this.editFormData) {
                         if (this.formData.hasOwnProperty(key)) {
                             this.formData[key] = this.editFormData[key]
                         }
                     }
                        
                     this.formData.pageId= this.editFormData.pageId+'';
                     this.photoArr = this.formData.photos.split(',')
                        // console.log('this.photoArr',this.photoArr)

                        this.$nextTick(()=>{//select赋值，图片赋值

                            let hasUpload = []
                            this.photoArr.map(item=>{
                                let fid = (item.split('_'))[0]
                                hasUpload.push({
                                     status:'finished',
                                     response:{data:fid}
                                })
                            })
                            this.$refs.upLogoImg.setHasUpload(hasUpload)

                        });
                    }
                   
                    this.title = this.type == 1?this.$t('productManage.addModel.title'):this.$t('productManage.editModel.title')

                } else { //关闭弹框后要做的处理
                 
                    this.resetForm();//重置表单
                    this.$refs.upLogoImg.clearImg()
                }
            },
            subData(name) {//提交表单
                // console.log(this.formData)
                // if(!this.formData.photos){
                //     common.msg('error',this.$t('productManage.validateAdd.photo'))
                //     return false
                // }

                this.$refs[name].validate((valid) => {
                    if (valid) {

                        this.disabled = true;

                        let url = ''
                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                            url = this.config.urlArray.editPages
                        }else{
                            url =  this.config.urlArray.addPages
                        }        
                        
                        
                        this.axios.post(url, {...this.formData,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false;
                            })
                            
                            
                        }).catch((err) => {
                            // common.msg('error',this.$t('failed'),()=>{this.disabled = false;})
                            // this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                this.fn1()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.photoArr = []
                this.formData.photos = ''
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
}
</script>
<style lang='less' scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-form-item-content{
    flex-grow: 1;
}
.selectButtonCon{
  /deep/ .ivu-form-item-content{
        display: flex;
    }
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.logoCon {
    /deep/ .ivu-form-item-content{
        margin-left: 0px !important;
    }
}
</style>
